export default __webpack_public_path__ + "img/InterDisplay-MediumItalic_00835fc.woff2";